import { useQuery } from "@tanstack/react-query"

import { useQueries } from "@/hooks/useRootContext.ts"
import { normalizeProjectKey } from "@/lib/std.ts"

import type { BatchInfo, ProjectKey } from "@/lib/client/generated/TypeDefinitions.ts"


export function useFindFiles(batchInfo: BatchInfo, projectKey: ProjectKey, repo: string, commit: string | null, inputValue: string) {
  const client = useQueries().apiClient
  return useQuery({
    queryKey: ["findFiles", normalizeProjectKey(projectKey), repo, commit, inputValue, batchInfo.offset],
    queryFn: () => {
      return client.findFiles(projectKey, repo, commit, inputValue, batchInfo)
    },
    placeholderData: (prev) => prev
  })
}